import React from "react";
import {Helmet} from "react-helmet";

class PageTitle extends React.Component {

  	render() {
		return (
			<div className="Page_Title">
	            <Helmet>
			        <title>Mobile App Development Company, Creator, Hire Developer | Digipanda</title>
			        <meta name="description" content="Digipanda Web Development" />
			    </Helmet>
			</div>
		);
	}
};

export default PageTitle;
